import Axios from "axios";
import { getQueriedUrl } from "@/helpers/queryStringHelper";
import {
  refundPaymentByIdRequest,
  refundSbpPaymentByIdRequest,
} from "@/helpers/api/payments";

export async function getRefundsRequest({ query }) {
  return Axios.get(
    getQueriedUrl({
      url: "/payment-refunds/",
      query: {
        ...query,
      },
    }),
  );
}

export async function getRefundReasonsRequest() {
  return Axios.get("/payment-refunds/reasons/");
}

export async function refundPaymentRequest({ id, formData, isSbp }) {
  if (isSbp) {
    return refundSbpPaymentByIdRequest({ id, formData });
  }
  return refundPaymentByIdRequest({ id, formData });
}
